module.exports = __webpack_public_path__ + "img/sign-up-banner-start-teaching.c491da8.jpg";